import React, { useEffect, useState } from 'react';
import { useRef } from 'react';

const Appointment = () => {
    const [formData, setFormData] = useState({
        name: '',
        mobile: '',
        date: '',
        location: '',
        url: ''
    });

    const [appointments, setAppointments] = useState([]);
    const [search, setSearch] = useState('');
    const [editIndex, setEditIndex] = useState(null);

    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 15;
    const [loading, setLoading] = useState(false);
    const fileInputRef = useRef(null);

    useEffect(() => {
        fetchAppointments();
    }, []);

    const fetchAppointments = async () => {
        try {
            const response = await fetch('https://botapi.emedha.in/pages/api/api/appointment');
            if (!response.ok) throw new Error('Failed to fetch appointments');
            const data = await response.json();
            setAppointments(data);
        } catch (error) {
            console.error('Error fetching appointments:', error);
        }
    };


    const [template, setTemplate] = useState(null);
    const [templateOptions, setTemplateOptions] = useState([]);
    useEffect(() => {
        const fetchTemplateOptions = async () => {
            try {
                const response = await fetch('https://emedha.com/echatbot/enotifier/getTemplateStatus.php?limit=10&wid=1055489806721185');
                const data = await response.json();
                setTemplateOptions(data.data);
            } catch (err) {
                console.log('Failed to load template options');
            }
        };

        fetchTemplateOptions();
    }, []);
    const TEMPLATE_LABELS = {
        'vasvi_apt_new': 'Normal',
        'vasavi_apt_renew': 'Normal Renewal',
        'vasavi_apt_tatkal': 'Tatkal',
        'vasavi_apt_tatkal_ren': 'Tatkal Renewal',
        'vasavi_apt_minor': 'Minor',
        'vasavi_apt_minor_re': 'Minor Renewal'
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg', 'application/pdf'];
        if (file && allowedTypes.includes(file.type)) {
            setFormData(prev => ({ ...prev, url: file }));
        } else {
            alert('Only image and PDF files are allowed.');
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const form = new FormData();
        Object.entries(formData).forEach(([key, value]) => form.append(key, value));
        form.append('template_name', template?.name || '');
        try {
            const response = await fetch('https://botapi.emedha.in/pages/api/api/appointmentpost', {
                method: 'POST',
                body: form
            });
            const result = await response.json();
            alert(result.message);
            if (!response.ok) throw new Error(result.message);
            if (editIndex !== null) {
                const updated = [...appointments];
                updated[editIndex] = formData;
                setAppointments(updated);
                setEditIndex(null);
            } else {
                setAppointments([...appointments, formData]);
            }
            setFormData({ name: '', mobile: '', date: '', location: '', url: null });
            fileInputRef.current.value = null;
        } catch (error) {
            alert('Failed to send appointment.');
        } finally {
            setLoading(false); // Stop loading
        }
    };



    const filteredAppointments = appointments.filter(item => {
        const matchesSearch = item.name.toLowerCase().includes(search.toLowerCase());
        const itemDate = new Date(item.date);
        const start = startDate ? new Date(startDate) : null;
        const end = endDate ? new Date(endDate) : null;

        const withinDateRange =
            (!start || itemDate >= start) &&
            (!end || itemDate <= end);

        return matchesSearch && withinDateRange;
    });

    // Pagination logic
    const totalPages = Math.ceil(filteredAppointments.length / itemsPerPage);
    const paginatedAppointments = filteredAppointments.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    return (
        <div className="container">
            <h2 className="text-center mb-4">Appointment Form</h2>

            <form onSubmit={handleSubmit} className="row g-3">
                <div className="col-md-6">
                    <input type="text" name="name" placeholder="Name" className="form-control" value={formData.name} onChange={handleChange} required />
                </div>
                <div className="col-md-6">
                    <input type="text" name="mobile" placeholder="Mobile" className="form-control" value={formData.mobile} onChange={handleChange} required />
                </div>
                <div className="col-md-6">
                    <input type="datetime-local" name="date" className="form-control" value={formData.date} onChange={handleChange} required min={new Date().toISOString().slice(0, 16)} />
                </div>
                <div className="col-md-6">
                    <input type="text" name="location" placeholder="Location" className="form-control" value={formData.location} onChange={handleChange} required />
                </div>
                <div className="col-md-6">
                    <input type="file" name="url" className="form-control" onChange={handleFileChange} required ref={fileInputRef} />
                </div>
                <div className="col-md-6">
                    <select className="form-control" value={template?.name || ''} required onChange={(e) => { const selectedName = e.target.value; const selectedTemplate = templateOptions.find(t => t.name === selectedName); setTemplate(selectedTemplate); }}>
                        <option value="">Select Template</option>
                        {templateOptions.filter(t => Object.keys(TEMPLATE_LABELS).includes(t.name)).map(opt => (
                            <option key={opt.id} value={opt.name}>{TEMPLATE_LABELS[opt.name]}</option>
                        ))}
                    </select>
                </div>

                <div className="col-12 text-end">
                    <button type="submit" className="btn btn-primary btn-sm" disabled={loading}>
                        {loading ? (<><span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>Sending...</>) : (editIndex !== null ? 'Update' : 'Send Message')}
                    </button>
                </div>
            </form>

            {/* Search and Date Filters */}
            <div className="row mb-3">
                <div className="col-md-4">
                    <label>Search By Name</label>
                    <input type="text" className="form-control" placeholder="Search by name" value={search} onChange={(e) => setSearch(e.target.value)} />
                </div>
                <div className="col-md-4">
                    <label>Start Date</label>
                    <input type="date" className="form-control" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
                </div>
                <div className="col-md-4">
                    <label>End Date</label>
                    <input type="date" className="form-control" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
                </div>
            </div>

            {/* Table */}
            <div className="table-responsive">
                <table className="table table-striped table-bordered text-center">
                    <thead className="table-dark">
                        <tr>
                            <th>Name</th>
                            <th>Mobile</th>
                            <th>Date</th>
                            <th>Location</th>
                            <th>File</th>
                        </tr>
                    </thead>
                    <tbody>
                        {paginatedAppointments.length > 0 ? (
                            paginatedAppointments.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.name}</td>
                                    <td>{item.mobile}</td>
                                    <td>{new Date(item.date).toLocaleString()}</td>
                                    <td>{item.location}</td>
                                    <td>{item.hurl ? (<a href={item.hurl} target="_blank" rel="noopener noreferrer">View File</a>) : 'No file'}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="5" className="text-muted">No records found.</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* Pagination Controls */}
            <div className="d-flex justify-content-center my-3">
                <button className="btn btn-secondary btn-sm mx-2" onClick={() => setCurrentPage(1)} disabled={currentPage === 1}>First</button>
                <button className="btn btn-secondary btn-sm mx-2" onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))} disabled={currentPage === 1}>Previous</button>
                <span className="align-self-center btn-sm mx-2">Page {currentPage} of {totalPages}</span>
                <button className="btn btn-secondary btn-sm mx-2" onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))} disabled={currentPage === totalPages}>Next</button>
                <button className="btn btn-secondary btn-sm mx-2" onClick={() => setCurrentPage(totalPages)} disabled={currentPage === totalPages}>Last</button>
            </div>
        </div>
    );
};

export default Appointment;










// import React, { useEffect, useState, useRef } from 'react';

// const Appointment = () => {
//     // Form data state
//     const [formData, setFormData] = useState({
//         name: '',
//         mobile: '',
//         date: '',
//         time: '',
//         location: '',
//         url: ''
//     });

//     const [appointments, setAppointments] = useState([]);
//     const [search, setSearch] = useState('');
//     const [startDate, setStartDate] = useState('');
//     const [endDate, setEndDate] = useState('');
//     const [currentPage, setCurrentPage] = useState(1);
//     const itemsPerPage = 15;

//     const [template, setTemplate] = useState(null);
//     const [templateOptions, setTemplateOptions] = useState([]);
//     const [editIndex, setEditIndex] = useState(null);
//     const [loading, setLoading] = useState(false);

//     const fileInputRef = useRef(null);

//     // Fetch appointments on mount
//     useEffect(() => {
//         fetchAppointments();
//     }, []);

//     // Fetch appointment data from API
//     const fetchAppointments = async () => {
//         try {
//             const response = await fetch('https://botapi.emedha.in/pages/api/api/appointment');
//             if (!response.ok) throw new Error('Failed to fetch appointments');
//             const data = await response.json();
//             setAppointments(data);
//         } catch (error) {
//             console.error('Error fetching appointments:', error);
//         }
//     };

//     // Fetch template options on mount
//     useEffect(() => {
//         const fetchTemplateOptions = async () => {
//             try {
//                 const response = await fetch(
//                     'https://emedha.com/echatbot/enotifier/getTemplateStatus.php?limit=10&wid=1055489806721185'
//                 );
//                 const data = await response.json();
//                 setTemplateOptions(data.data);
//             } catch (err) {
//                 console.log('Failed to load template options');
//             }
//         };
//         fetchTemplateOptions();
//     }, []);

//     // Map template names to user-friendly labels
//     const TEMPLATE_LABELS = {
//         vasvi_apt_new: 'Normal',
//         vasavi_apt_renew: 'Normal Renewal',
//         vasavi_apt_tatkal: 'Tatkal',
//         vasavi_apt_tatkal_ren: 'Tatkal Renewal',
//         vasavi_apt_minor: 'Minor',
//         vasavi_apt_minor_re: 'Minor Renewal'
//     };

//     // Handle input change for form fields
//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setFormData((prev) => ({ ...prev, [name]: value }));
//     };

//     // Handle file input change
//     const handleFileChange = (e) => {
//         const file = e.target.files[0];
//         const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg', 'application/pdf'];
//         if (file && allowedTypes.includes(file.type)) {
//             setFormData((prev) => ({ ...prev, url: file }));
//         } else {
//             alert('Only image and PDF files are allowed.');
//         }
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setLoading(true);
//         const form = new FormData();
//         form.append('name', formData.name);
//         form.append('mobile', formData.mobile);
//         form.append('date', formData.date);
//         form.append('time', formData.time);
//         form.append('location', formData.location);
//         if (formData.url) form.append('url', formData.url);
//         form.append('template_name', template.name);
//         try {
//             const response = await fetch('https://botapi.emedha.in/pages/api/api/appointmentpost', {
//                 method: 'POST',
//                 body: form
//             });
//             const result = await response.json();
//             alert(result.message);
//             if (!response.ok) throw new Error(result.message);
//             if (editIndex !== null) {
//                 const updated = [...appointments];
//                 updated[editIndex] = formData;
//                 setAppointments(updated);
//                 setEditIndex(null);
//             } else {
//                 setAppointments([...appointments, formData]);
//             }
//             setFormData({ name: '', mobile: '', date: '', location: '', url: null });
//             fileInputRef.current.value = null;
//         } catch (error) {
//             alert('Failed to send appointment.');
//         }
//     };

//     // Filter appointments by search and date range
//     const filteredAppointments = appointments.filter((item) => {
//         const matchesSearch = item.name.toLowerCase().includes(search.toLowerCase());
//         const itemDate = new Date(item.date);
//         const start = startDate ? new Date(startDate) : null;
//         const end = endDate ? new Date(endDate) : null;

//         const withinDateRange = (!start || itemDate >= start) && (!end || itemDate <= end);

//         return matchesSearch && withinDateRange;
//     });

//     // Pagination
//     const totalPages = Math.ceil(filteredAppointments.length / itemsPerPage);
//     const paginatedAppointments = filteredAppointments.slice(
//         (currentPage - 1) * itemsPerPage,
//         currentPage * itemsPerPage
//     );

//     // Format time string from "HH:mm" to 12-hour with AM/PM
//     const formatTime12 = (time) => {
//         if (!time) return '';
//         const [hourStr, minute] = time.split(':');
//         let hour = parseInt(hourStr, 10);
//         const ampm = hour >= 12 ? 'PM' : 'AM';
//         hour = hour % 12 || 12; // convert 0 to 12 for 12 AM
//         return `${hour}:${minute} ${ampm}`;
//     };

//     return (
//         <div className="container">
//             <h2 className="text-center mb-4">Appointment Form</h2>

//             {/* Appointment Form */}
//             <form onSubmit={handleSubmit} className="row g-3">
//                 <div className="col-md-6">
//                     <input type="text" name="name" placeholder="Name" className="form-control" value={formData.name} onChange={handleChange} required />
//                 </div>
//                 <div className="col-md-6">
//                     <input type="text" name="mobile" placeholder="Mobile" className="form-control" value={formData.mobile} onChange={handleChange} required />
//                 </div>
//                 <div className="col-md-6">
//                     <input type="date" name="date" className="form-control" value={formData.date} onChange={handleChange} required min={new Date().toISOString().split('T')[0]} />
//                 </div>
//                 <div className="col-md-6">
//                     <input type="time" name="time" className="form-control" value={formData.time} onChange={handleChange} required />
//                 </div>

//                 <div className="col-md-6">
//                     <input type="text" name="location" placeholder="Location" className="form-control" value={formData.location} onChange={handleChange} required />
//                 </div>
//                 <div className="col-md-6">
//                     <input type="file" name="url" className="form-control" onChange={handleFileChange} required ref={fileInputRef} />
//                 </div>
//                 <div className="col-md-6">
//                     <select
//                         className="form-control"
//                         value={template?.name || ''}
//                         required
//                         onChange={(e) => {
//                             const selectedName = e.target.value;
//                             const selectedTemplate = templateOptions.find((t) => t.name === selectedName);
//                             setTemplate(selectedTemplate);
//                         }}
//                     >
//                         <option value="">Select Template</option>
//                         {templateOptions
//                             .filter((t) => Object.keys(TEMPLATE_LABELS).includes(t.name))
//                             .map((opt) => (
//                                 <option key={opt.id} value={opt.name}>
//                                     {TEMPLATE_LABELS[opt.name]}
//                                 </option>
//                             ))}
//                     </select>
//                 </div>

//                 <div className="col-12 text-end">
//                     <button type="submit" className="btn btn-primary" disabled={loading}>
//                         {loading ? (
//                             <>
//                                 <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
//                                 Sending...
//                             </>
//                         ) : (
//                             'Send Message'
//                         )}
//                     </button>
//                 </div>

//             </form>

//             {/* Search and Date Filters */}
//             <div className="row mb-3 mt-4">
//                 <div className="col-md-4">
//                     <label>Search By Name</label>
//                     <input type="text" className="form-control" placeholder="Search by name" value={search} onChange={(e) => setSearch(e.target.value)} />
//                 </div>
//                 <div className="col-md-4">
//                     <label>Start Date</label>
//                     <input type="date" className="form-control" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
//                 </div>
//                 <div className="col-md-4">
//                     <label>End Date</label>
//                     <input type="date" className="form-control" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
//                 </div>
//             </div>

//             {/* Appointment Table */}
//             <div className="table-responsive">
//                 <table className="table table-striped table-bordered text-center">
//                     <thead className="table-dark">
//                         <tr>
//                             <th>Name</th>
//                             <th>Mobile</th>
//                             <th>Date</th>
//                             <th>Time</th>
//                             <th>Location</th>
//                             <th>File</th>
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {paginatedAppointments.length > 0 ? (
//                             paginatedAppointments.map((item, index) => (
//                                 <tr key={index}>
//                                     <td>{item.name}</td>
//                                     <td>{item.mobile}</td>
//                                     {/* Format date as local date */}
//                                     <td>{new Date(item.date).toLocaleDateString()}</td>
//                                     {/* Format time in 12-hour AM/PM */}
//                                     <td>{formatTime12(item.time)}</td>
//                                     <td>{item.location}</td>
//                                     <td>
//                                         {item.hurl ? (
//                                             <a href={item.hurl} target="_blank" rel="noopener noreferrer">
//                                                 View File
//                                             </a>
//                                         ) : (
//                                             'No file'
//                                         )}
//                                     </td>
//                                 </tr>
//                             ))
//                         ) : (
//                             <tr>
//                                 <td colSpan="6" className="text-muted">
//                                     No records found.
//                                 </td>
//                             </tr>
//                         )}
//                     </tbody>
//                 </table>
//             </div>

//             {/* Pagination Controls */}
//             <div className="d-flex justify-content-center my-3">
//                 <button className="btn btn-secondary btn-sm mx-2" onClick={() => setCurrentPage(1)} disabled={currentPage === 1}>First</button>
//                 <button className="btn btn-secondary btn-sm mx-2" onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))} disabled={currentPage === 1}>Previous</button>
//                 <span className="align-self-center btn-sm mx-2">Page {currentPage} of {totalPages}</span>
//                 <button className="btn btn-secondary btn-sm mx-2" onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))} disabled={currentPage === totalPages}>Next</button>
//                 <button className="btn btn-secondary btn-sm mx-2" onClick={() => setCurrentPage(totalPages)} disabled={currentPage === totalPages}>Last</button>
//             </div>

//         </div>
//     );
// };

// export default Appointment;
